<template>
    <sidebar-left>
        <slot slot="sidebar-left">
            <SideMenu :SideMenuLinks="SideMenuLinks"></SideMenu>
        </slot>
        <slot slot="main">
            <div class="u-max-700 u-center-block">
                <v-loading type="global" :data="Personal"></v-loading>
                <page-header>
                    <slot slot="title">{{ $t('customer.account.edit.title') }}</slot>
                    <slot slot="description">
                        <p>{{ $t('customer.account.edit.description') }}</p>
                    </slot>
                </page-header>

                <section class="c-form-row o-page-bottom-spacing--medium">
                    <form action="" enctype="multipart/form-data" class="c-form c-form--horizontal">

                        <h2 class="c-title--border u-h3">
                            {{ $t('customer.account.edit.form.personal.title') }}
                        </h2>

                        <v-form-row>
                            <v-input v-model="Personal.FirstName" name="personal_first_name" :fluid="true" :error="Validate.FirstName">
                                <slot slot="label">{{ $t('users.first_name') }}</slot>
                            </v-input>
                        </v-form-row>

                        <v-form-row>
                            <v-input v-model="Personal.LastName" name="personal_last_name" :fluid="true" :error="Validate.LastName">
                                <slot slot="label">{{ $t('users.last_name') }}</slot>
                            </v-input>
                        </v-form-row>

                        <v-form-row>
                            <v-input v-model="Personal.SalesTakerCode" name="personal_sales_taker_code" :fluid="true" :error="Validate.SalesTakerCode">
                                <slot slot="label">{{ $t('users.sales_taker_code') }}</slot>
                            </v-input>
                        </v-form-row>

                        <v-form-row>
                            <v-input v-model="Personal.PhoneNumber" name="personal_phone" type="tel" :fluid="true" :error="Validate.PhoneNumber">
                                <slot slot="label">{{ $t('customer.account.edit.form.personal.phone.label') }}</slot>
                            </v-input>
                        </v-form-row>

                        <v-form-row>
                            <v-input v-model="Personal.Email" name="personal_email" type="email" :fluid="true"
                                     :error="Validate.Email">
                                <slot slot="label">{{ $t('customer.account.edit.form.personal.email.label') }}</slot>
                            </v-input>
                        </v-form-row>

                        <v-form-row>
                            <div class="c-form-item c-form-item--horizontal c-form-item--fluid">
                                <label class="c-label">Profielfoto</label>
                                <div class="u-inline-block u-pos-relative" style="width: 200px">
                                    <v-picture-input
                                            :width="200"
                                            :height="200"
                                            :selected="Personal.Photo"
                                            @changed="setProfilePicture">
                                    </v-picture-input>
                                </div>
                            </div>
                        </v-form-row>

                        <v-form-row>
                            <div class="c-form-item c-form-item--horizontal">
                                <v-label></v-label>
                                <button @click.prevent="submitPersonal" class="c-button c-button--alpha">
                                    {{ $t('customer.account.edit.form.personal.submit') }}
                                </button>
                            </div>
                        </v-form-row>
                    </form>
                </section>

                <section class="c-form-row o-page-bottom-spacing--medium">
                    <form action="" class="c-form c-form--horizontal">

                        <h2 class="c-title--border u-h3">
                            {{ $t('customer.account.edit.form.password.title') }}
                        </h2>

                        <v-form-row>
                            <v-input v-model="Password.OldPassword" name="old_password" type="password" :fluid="true"
                                     :error="Validate.OldPassword">
                                <slot slot="label">{{ $t('customer.account.edit.form.password.old_password.label') }}</slot>
                            </v-input>
                        </v-form-row>

                        <v-form-row>
                            <v-input v-model="Password.NewPassword" name="new_password" type="password" :fluid="true"
                                     :error="Validate.NewPassword">
                                <slot slot="label">{{ $t('customer.account.edit.form.password.new_password.label') }}</slot>
                            </v-input>
                        </v-form-row>

                        <v-form-row>
                            <v-input v-model="Password.ConfirmPassword" name="confirm_password" type="password" :fluid="true"
                                     :error="Validate.ConfirmPassword">
                                <slot slot="label">{{ $t('customer.account.edit.form.password.confirm_password.label') }}</slot>
                            </v-input>
                        </v-form-row>

                        <div class="c-form-row">
                            <div class="c-form-item c-form-item--horizontal c-form-item--fluid">
                                <label class="c-label"></label>
                                <div class="u-inline-block u-pos-relative u-fullwidth">
                                    <p class="u-font-small">{{ $t('customer.account.register.password_minimum_length') }}</p>
                                </div>
                            </div>
                        </div>

                        <v-form-row>
                            <div class="c-form-item c-form-item--horizontal">
                                <v-label></v-label>
                                <button @click.prevent="submitPassword" class="c-button c-button--alpha" :disabled="validatePassword">
                                    {{ $t('customer.account.edit.form.password.title') }}
                                </button>
                            </div>
                        </v-form-row>
                    </form>
                </section>

            </div>
        </slot>
    </sidebar-left>
</template>

<script>
    import VLoading from '@/components/Loading'
    import VTextarea from '@/components/form/Textarea'
    import VInput from '@/components/form/Input'
    import VPictureInput from '@/components/form/PictureInput'
    import VSelect from '@/components/form/Select'
    import VCustomSelect from '@/components/form/CustomSelect'
    import VFormRow from '@/components/form/Row'
    import VLabel from '@/components/form/Label'
    import VTargetListSelect from '@/components/form/targetList/TargetListSelect'
    import VSwitch from '@/components/form/Switch'
    import PageHeader from '@/components/common/PageHeader'
    import SideMenu from '@/components/common/SideMenu'
    import SidebarLeft from '@/components/layout/SidebarLeft'

    // Store
    import {mapGetters} from 'vuex'

    export default {
        components: {
            PageHeader,
            SideMenu,
            SidebarLeft,
            VTextarea,
            VSelect,
            VCustomSelect,
            VLabel,
            VInput,
            VPictureInput,
            VFormRow,
            VTargetListSelect,
            VSwitch,
            VLoading
        },
        data() {
            return {
                SideMenuLinks: [
                    {
                        title: 'customer.account.edit.title',
                        route: '/salesman/account/edit',
                    }
                ],
                Password: {
                    OldPassword: '',
                    NewPassword: '',
                    ConfirmPassword: ''
                },
                Validate: {}
            }
        },
        created() {
            this.$store.dispatch('getUser').catch((e) => {
                this.notifyError(e.Message);
            });
        },
        computed: {
            ...mapGetters({
                Personal: 'userPersonalData'
            }),
            validatePassword() {
                return (this.Password.ConfirmPassword === '' || this.Password.NewPassword === '' || this.Password.OldPassword === '')
            }
        },
        methods: {
            validateForm(response) {
                let errors = response;

                // Get error data from server, and transform to vue data
                Object.keys(errors).forEach(function(key) {
                    key = key.replace('model.', '');
                    errors[key] = errors['model.'+key][0];
                    delete errors['model.'+key];
                });

                this.Validate = errors;
            },
            submitPersonal() {
                this.$store.dispatch('sendUser', this.Personal).then(() => {
                    this.notifySuccess('Persoonlijke gegevens');
                    this.Validate = {};
                }).catch((e) => {
                    this.notifyError(e.Message);
                    this.validateForm(e.ModelState);
                });
            },
            submitPassword() {
                this.$store.dispatch('changePassword', this.Password).then(() => {
                    this.notifySuccess('Wachtwoord gewijzigd');
                    this.Validate = {};
                }).catch((e) => {
                    this.notifyError(e.Message);
                    this.validateForm(e.ModelState);
                });
            },

            setProfilePicture(picture) {
                this.$set(this.Personal, 'Photo', picture)
            },

            notifySuccess(title) {
                this.$notify({
                    group: 'global',
                    title: title,
                    text: this.$t('global.saved'),
                    type: 'success',
                    duration: 4000
                });
            },
            notifyError(title) {
                this.$notify({
                    group: 'global',
                    title: title,
                    text: this.$t('global.error_occured'),
                    type: 'error',
                    duration: 5000
                });
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/salesman/account/Edit.vue